import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconColor } from '@freelancer/ui/icon';
import { LinkColor } from '@freelancer/ui/link';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';
import { UpgradeTagSize, UpgradeType } from '@freelancer/ui/upgrade-tag';
import { ManageTableType } from 'app/manage/shared/manage.types';

@Component({
  selector: 'app-manage-quotation-title',
  template: `
    <div class="Title">
      <fl-link
        [flMarginRight]="'xxsmall'"
        [flTrackingLabel]="'QuotationTitleClick'"
        [flTrackingReferenceType]="'quotation_uid'"
        [flTrackingReferenceId]="quotationUid"
        [link]="'/quotation/' + quotationUid + '/view'"
        [color]="LinkColor.INHERIT"
      >
        <fl-text
          [color]="FontColor.INHERIT"
          [maxLines]="2"
          [size]="size"
          [sizeTablet]="sizeTablet"
        >
          {{ titleText }}
        </fl-text>
      </fl-link>
    </div>
  `,
  styleUrls: ['./manage-quotation-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageQuotationTitleComponent {
  FontColor = FontColor;
  FontWeight = FontWeight;
  LinkColor = LinkColor;
  ManageTableType = ManageTableType;
  UpgradeTagSize = UpgradeTagSize;
  UpgradeType = UpgradeType;
  IconColor = IconColor;

  @Input() quotationUid: string;
  @Input() size: TextSize = TextSize.XSMALL;
  @Input() sizeTablet: TextSize = TextSize.XSMALL;
  @Input() titleText: string;
}
